/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
==========================================================================================*/
import axios from '@/axios.js'
export default {
  login ({ commit, dispatch}, authData) {

    // axios.defaults.headers.common['Access-Control-Allow-Origin']    = '*'
    // axios.defaults.headers.common['Access-Control-Request-Method']  = '*'
    // axios.defaults.headers.common['Access-Control-Allow-Origin']    = true

    return new Promise((resolve, reject) => {
      axios.post(`${axios.defaults.baseURL}/login`,
        {
          username: authData.userDetails.email,
          password: authData.userDetails.password
        }
      ).then(response => {
        console.log(response)
        commit('SET_TOKEN', response.data.access_token)
        localStorage.setItem('access_token', response.data.access_token)
        dispatch('activeUser')
        resolve(response)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  destroyToken (context) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${context.state.token}`
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        axios.post(`${axios.defaults.baseURL}/logout`
        ).then(response => {
          localStorage.removeItem('access_token')
          localStorage.removeItem('userInfo')
          context.commit('DESTROY_TOKEN')
          resolve(response)
        }).catch(error => {
          localStorage.removeItem('access_token')
          localStorage.removeItem('userInfo')
          context.commit('DESTROY_TOKEN')
          reject(error)
        })
      })
    }
  },
  activeUser (context) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${context.state.token}`
    axios.get(`${axios.defaults.baseURL}/user`
    ).then(response => {
      console.log('user info in main', response.data)
      // localStorage.setItem('userInfo', JSON.stringify(response.data))
      // context.commit('UPDATE_USER_INFO', response.data)
      // Update user details
      context.commit('UPDATE_USER_INFO', response.data, {root: true})
    })
  }
}

